import React, { useEffect, useState, useRef } from 'react';
import { LanguageSelector } from './components/LanguageSelector';
import { SlideOne } from './components/SlideOne';
import { SlideTwo } from './components/SlideTwo';
import { SlideThree } from './components/SlideThree';
import { SlideFour } from './components/SlideFour';
import { SlideFive } from './components/SlideFive';
import { ProgressIndicator } from './components/ProgressIndicator';
import { CountdownTimer } from './components/CountdownTimer';
import { Footer } from './components/Footer';
export function App() {
  // Slide 0 = language, 1 = poll, 2 = results, 3 = Nils, 4 = CTA options, 5 = form
  const [currentSlide, setCurrentSlide] = useState<number>(0);
  const [isTransitioning, setIsTransitioning] = useState<boolean>(false);
  const [selectedLanguage, setSelectedLanguage] = useState<string | null>(null);
  const [selectedOption, setSelectedOption] = useState<string | null>(null);
  const [selectedCTA, setSelectedCTA] = useState<string | null>(null);
  // Timer state
  const [elapsed, setElapsed] = useState(0);
  const [timerRunning, setTimerRunning] = useState(false);
  const [finalElapsed, setFinalElapsed] = useState<number | null>(null);
  const intervalRef = useRef<ReturnType<typeof setInterval> | null>(null);
  // Start/stop timer
  useEffect(() => {
    if (timerRunning) {
      intervalRef.current = setInterval(() => {
        setElapsed(prev => prev + 1);
      }, 1000);
    } else {
      if (intervalRef.current) clearInterval(intervalRef.current);
    }
    return () => {
      if (intervalRef.current) clearInterval(intervalRef.current);
    };
  }, [timerRunning]);
  const transition = (callback: () => void) => {
    if (isTransitioning) return;
    setIsTransitioning(true);
    setTimeout(() => {
      callback();
      setIsTransitioning(false);
    }, 300);
  };
  const goTo = (slide: number) => {
    // Stop timer when reaching CTA page (slide 4)
    if (slide === 4 && finalElapsed === null) {
      setTimerRunning(false);
      setFinalElapsed(elapsed);
    }
    transition(() => setCurrentSlide(slide));
  };
  const handleLanguageSelect = (lang: string) => {
    setSelectedLanguage(lang);
    setTimerRunning(true);
    goTo(1);
  };
  const handlePollNext = (option: string) => {
    setSelectedOption(option);
    goTo(2);
  };
  const handleBack = () => {
    if (currentSlide <= 0) return;
    if (currentSlide === 4) {
      goTo(3);
    } else if (currentSlide === 5) {
      goTo(4);
    } else {
      transition(() => setCurrentSlide(prev => prev - 1));
    }
  };
  const handleGoToCTA = () => goTo(4);
  const handleSelectCTA = (option: string) => {
    setSelectedCTA(option);
    goTo(5);
  };
  const handleNextSlide = () => {
    if (currentSlide < 3) {
      transition(() => setCurrentSlide(prev => prev + 1));
    }
  };
  // Show progress dots only for content slides 1-3
  const showProgress = currentSlide >= 1 && currentSlide <= 3;
  const showRunningTimer = currentSlide >= 1 && currentSlide <= 3;
  return <div className="min-h-screen w-full bg-solventum-bg flex flex-col items-center justify-between px-6 py-4 overflow-hidden selection:bg-solventum-primary selection:text-solventum-bg" data-id="element-0">
      {/* Running countdown timer on content slides */}
      {showRunningTimer && <div className="w-full max-w-lg flex justify-end pt-1 pb-2" data-id="element-1">
          <CountdownTimer elapsed={elapsed} data-id="element-2" />
        </div>}

      <main className="flex-1 w-full max-w-lg flex flex-col justify-center relative" data-id="element-3">
        <div className={`transition-opacity duration-300 w-full h-full flex items-center ${isTransitioning ? 'opacity-0' : 'opacity-100'}`} data-id="element-4">
          {currentSlide === 0 && <LanguageSelector onSelect={handleLanguageSelect} data-id="element-5" />}
          {currentSlide === 1 && <SlideOne onNext={handlePollNext} onCTA={handleGoToCTA} data-id="element-6" />}
          {currentSlide === 2 && <SlideTwo onNext={handleNextSlide} onBack={handleBack} onCTA={handleGoToCTA} selectedOption={selectedOption} data-id="element-7" />}
          {currentSlide === 3 && <SlideThree selectedOption={selectedOption} onBack={handleBack} onCTA={handleGoToCTA} data-id="element-8" />}
          {currentSlide === 4 && <SlideFour onSelectCTA={handleSelectCTA} onBack={handleBack} selectedOption={selectedOption} elapsedSeconds={finalElapsed ?? elapsed} data-id="element-9" />}
          {currentSlide === 5 && <SlideFive ctaOption={selectedCTA} onBack={handleBack} data-id="element-10" />}
        </div>
      </main>

      <div className="w-full max-w-lg flex flex-col items-center mt-4" data-id="element-11">
        {showProgress && <ProgressIndicator total={3} current={currentSlide} data-id="element-12" />}
        <Footer data-id="element-13" />
      </div>
    </div>;
}